import { NgModule } from '@angular/core';

import { ProgressIndicatorComponent } from './progressIndicator.component';

@NgModule({
  declarations: [
    ProgressIndicatorComponent,
  ],
  exports: [
    ProgressIndicatorComponent,
  ],
  providers: [],
})
export class ProgressIndicatorModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/ProgressIndicatorComponent/progressIndicator.module.ts